import React from 'react';
import ThumbsUpIcon from 'assets/images/videoReactions/ThumbsUpIcon';
import LaughingIcon from 'assets/images/videoReactions/LaughingIcon';
import ThumbsDownIcon from 'assets/images/videoReactions/ThumbsDownIcon';
import ClappingIcon from 'assets/images/videoReactions/ClappingIcon';
import LoveItIcon from 'assets/images/videoReactions/LoveItIcon';
import WowIcon from 'assets/images/videoReactions/WowIcon';
import vehicleThumbnail1 from '../../assets/vehicle-thumbnails/vehicle1.png';
import vehicleThumbnail2 from '../../assets/vehicle-thumbnails/vehicle2.png';
import vehicleThumbnail3 from '../../assets/vehicle-thumbnails/vehicle3.png';
import vehicleThumbnail4 from '../../assets/vehicle-thumbnails/vehicle4.png';
import vehicleThumbnail5 from '../../assets/vehicle-thumbnails/vehicle5.png';
import vehicleThumbnail6 from '../../assets/vehicle-thumbnails/vehicle6.png';
import vehicleThumbnail7 from '../../assets/vehicle-thumbnails/vehicle7.png';
import { IconType } from '../../helpers/socialIcons';
import { LP_DESIGN_LOGO } from '../../constants';

import {
  CovideoLogoBlack,
  CovideoLogoGreenPrimary,
  CovideoLogoWhite,
  CovideoLogoWhiteGreen,
  CdkLogoWhite,
  CdkLogoDark,
} from 'assets/icons/covideo';

// body
export const VIDEO_PLAYER_THUMBNAIL_LIST = [
  vehicleThumbnail1,
  vehicleThumbnail2,
  vehicleThumbnail3,
  vehicleThumbnail4,
  vehicleThumbnail5,
  vehicleThumbnail6,
  vehicleThumbnail7,
];

export const REACTIONS = [
  <ThumbsUpIcon width={14} height={14} />,
  <ThumbsDownIcon width={14} height={14} />,
  <LaughingIcon width={14} height={14} />,
  <LoveItIcon width={14} height={14} />,
  <ClappingIcon width={14} height={14} />,
  <WowIcon width={14} height={14} />,
];

export const vehicleData = {
  condition: 'New',
  engine: '2.4L I4 16V MPFI DOHC',
  make: 'Mitsubishi',
  model: 'RVR',
  trim: 'GT 4WD',
  year: '2024',
  mileage: '31',
  extColor: 'Diamond Red',
  transmission: 'CVT',
  vin: 'JA4AJVAWXRU605399',
  stock: 'New',
};
export const VEHICLE_DETAILS = Object.entries(vehicleData).map(
  ([key, value]) => ({
    label: key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .replace('Ext Color', 'Ext. Color'),
    value,
  })
);

export const SOCIAL_ICONS: IconType[] = [
  'x',
  'instagram',
  'facebook',
  'dealerrater',
  'yelp',
  'tiktok',
  'pinterest',
  'whatsapp',
  'linkedin',
  'bni',
  'youtube',
  'edmunds',
  'zeemee',
  'carsdotcom',
];

export const getFooterLogo = (
  logoSize: { width?: number; height?: number } = {}
) => {
  const defaultSize = { width: 78, height: 19 };
  const finalSize = { ...defaultSize, ...logoSize };

  return {
    // COVIDEO
    [LP_DESIGN_LOGO.WHITE]: <CovideoLogoWhite {...finalSize} />,
    [LP_DESIGN_LOGO.BLACK]: <CovideoLogoBlack {...finalSize} />,
    [LP_DESIGN_LOGO.COLOR]: <CovideoLogoGreenPrimary {...finalSize} />,
    [LP_DESIGN_LOGO.COLOR_WHITE_TEXT]: <CovideoLogoWhiteGreen {...finalSize} />,
    // CDK
    [LP_DESIGN_LOGO.CDK_WHITE]: <CdkLogoWhite {...finalSize} />,
    [LP_DESIGN_LOGO.CDK_BLACK]: <CdkLogoDark {...finalSize} />,
  };
};
